import {Component, Input, NgZone, OnDestroy, OnInit} from '@angular/core';
import {ChooseSizeDialogComponent} from '../../../builder/choose-size-dialog/choose-size-dialog.component';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {ProjectService} from '../../../shared/services/project.service';
import {Project} from '../../../shared/models/project';
import {CartService} from '../../../shared/services/cart.service';
import {ProductsService} from '../../../shared/services/products.service';
import {Router} from '@angular/router';
import {WaitModalComponent} from '../../../wait-modal/wait-modal.component';
import {LargeImageDialogComponent} from '../../../shared/components/large-image-dialog/large-image-dialog.component';
import {MouldingMerchDialogComponent} from '../../moulding-merch-dialog/moulding-merch-dialog.component';
import {SelectorDialogComponent} from '../../../builder/selector-dialog/selector-dialog.component';
import {Opening} from '../../../shared/models/opening';
import {Shape} from '../../../shared/models/shape';
import {Size} from '../../../shared/models/size';
import {SeoService} from '../../../shared/services/seo.service';
import {Subscription} from "rxjs";
import {UserDialogComponent} from "../../../user-dialog/user-dialog.component";

@Component({
  selector: 'mbnm-shop-detail-product-block',
  templateUrl: './shop-detail-product-block.component.html',
  styleUrls: ['./shop-detail-product-block.component.scss'],
  host: {
    '[class.no-button]': 'this.product.builderButton && this.product.builderButton.link === "NONE"'
  }
})
export class ShopDetailProductBlockComponent implements OnInit, OnDestroy {

  constructor(public dialog: MatDialog, private productsService: ProductsService, private zone: NgZone,
              private projectService: ProjectService, private cartService: CartService, private seoService: SeoService,
              private router: Router) { }

  @Input()
  product: any;

  private selectedProductChangeSubRef: Subscription;
  private cartChangedSubRef: Subscription;
  private projectChangeSubRef: Subscription;
  public projectIsPreview = false;

  async primaryButtonClicked($event) {
    $event.currentTarget.blur();
    if (this.product.project && !this.projectIsPreview) {
      await this.addToCart();
    } else if (this.product.sizeSelector !== 'NONE') {
      this.chooseSize();
    } else if (this.product.builderButton.link) {
      if (this.product.builderButton.link[0] === '/') {
        this.router.navigateByUrl(this.product.builderButton.link);
      } else {
        this.router.navigateByUrl('/buy/' + this.product.builderButton.link);
      }
    }
  }

  toolTip(image): string {
    if ( this.product.builderButton.link && this.product.builderButton.link !== 'NONE' && this.product.thumbFollowsLink === true) {
      return null;
    } else if (image && this.product.image?.largeImageSrc) {
      return 'Click to Enlarge';
    } else if (this.product.projectData && this.product.projectData.moulding) {
      return 'Click for More Information';
    }
    return null;
  }

  showThumbOrRedirect(image: string): void {
    if ( this.product.builderButton.link && this.product.builderButton.link !== 'NONE' && this.product.thumbFollowsLink === true) {
      if (this.product.builderButton.link[0] === '/') {
        this.router.navigateByUrl(this.product.builderButton.link);
      } else {
        this.router.navigateByUrl('/buy/' + this.product.builderButton.link);
      }
    } else if (image) {
      this.dialog.open(LargeImageDialogComponent, {
        data: {
          largeImage: image
        }
      });
    } else if (this.product.projectData && this.product.projectData.moulding) {
      const config = new MatDialogConfig();
      config.panelClass = 'fullscreen';

      const dialogRef = this.dialog.open(MouldingMerchDialogComponent, config);
      dialogRef.componentInstance.moulding = this.product.projectData.moulding;
      dialogRef.componentInstance.hangerType = this.product.project.frameHangerType;
      dialogRef.afterClosed().subscribe( (result) => {
        if (result && this.product.builderButton.link && this.product.builderButton.link !== 'NONE') {
          this.router.navigateByUrl('/buy/' + this.product.builderButton.link);
        }
      });
    }
  }

  chooseSize(): void {

    const config = new MatDialogConfig();
    config.panelClass = 'fullscreen';

    const dialogRef = this.dialog.open(ChooseSizeDialogComponent, config);

    dialogRef.componentInstance.mode = this.product.sizeSelector;
    dialogRef.componentInstance.standardSizeFilterList = this.product.availableStandardSizes ? this.product.availableStandardSizes : null;
    dialogRef.componentInstance.maxCustomSize = this.product.maxCustomSize;

    if (this.product.sizeSelector) {
      switch (this.product.sizeSelector.split('-')[1]) {
        case 'SHOWBAG': {
          dialogRef.componentInstance.title = 'Choose a Show Bag Size';
        }
          break;
        case 'SHOWKIT': {
          dialogRef.componentInstance.title = 'Choose a Show Kit Size';
        }
          break;
      }
    }

    dialogRef.afterClosed().subscribe(async (results: any) => {
      if (results) {
        if (this.product.project.size) this.product.project.size.destroy();
        this.product.project.size = new Size(results.outer[0], results.outer[1]);

        // special case, remove opening if selected size doesn't have one
        if (results.opening && results.opening[0] === 0 && results.opening[1] === 0) {
          this.product.project.clearOpenings();
        }

        if (results.opening && results.opening[0] !== 0 && results.opening[1] !== 0) {
          this.product.project.clearOpenings();
          this.product.project.addOpening(new Opening(new Size(results.opening[0], results.opening[1]), [Shape.DEFAULT]));
        }

        const qty = this.product.qtyBoxValues ? this.product.qtyBoxValues[0] : 1;
        this.product.project.qty = this.product.project.qty ? this.product.project.qty : qty;

        if (this.product.project.primaryProduct === 'SHOW-KIT') {
          const bag = this.bagData.filter((bag) => {
            const rotatedMatSize = bag.matSize.split(' x ').reverse().join(' x ');
            const outerSize = this.product.project.size.toNumericString().replace('x', '" x ') + '"';
            return bag.matSize === outerSize || rotatedMatSize === outerSize;
          })[0];

          if (!bag.active || !this.product.project.backingBoard.active) {
            const dialogRef2 = this.dialog.open(WaitModalComponent, {});
            const instance = dialogRef2.componentInstance;
            dialogRef2.disableClose = true;

            instance.titles = {
              ERROR: 'Item Temporarily Out of Stock',
            };

            instance.text = {
              ERROR: !bag.active ?
                'The show bag required for the size show kit you selected is temporarily out of stock. Please pick a different size show kit.' :
                'The backing board required for this show kit is temporarily out of stock.  Please try again later.'
            };
            instance.state = 'ERROR';
            return;
          } else {
            this.product.project.bag = bag;
          }
        }

        this.chooseNextUnselected();
      }
    });
  }

  chooseNextUnselected():void {
    ['topMat', 'bottomMat', 'moulding', 'backingBoard', 'glazing'].some( prop => {
      const cat = this.productCategories[prop];
      const projectData = this.product.projectData[cat.projectDataProperty];

      // if no selections have been made
      if (cat.selection.length === 0) {
        // if multiple options available
        if (this.multiOption(projectData, cat.projectProperty === 'bottomMat' ? 1 : 0)) {
          this.openSelectorDialog(cat);
          return true;
        }
      }
    });
  }

  multiOption(dataOptions: any, idx: number = 0): boolean {
    // if first level has multi options (if exists) and second level has multi options (if exists)
    return dataOptions && (Array.isArray(dataOptions) && dataOptions.length > 1 || (Array.isArray(dataOptions[idx]) && dataOptions[idx].length > 1));
  }

  openSelectorDialog(productCategory: any) {
    let dialogRef = this.dialog.open(SelectorDialogComponent);

    let instance = dialogRef.componentInstance;
    instance.project = this.product.project;
    instance.productCategory = productCategory;
    instance.showSamplesButton = false;

    if (this.selectedProductChangeSubRef && !this.selectedProductChangeSubRef.closed) {
      this.selectedProductChangeSubRef.unsubscribe();
    }

    this.selectedProductChangeSubRef = instance.selectedProductChange.subscribe((newValues: any) => {
      this.product.project[productCategory.projectProperty] = newValues[0];
      productCategory.selection = newValues;
      dialogRef.close();
      this.chooseNextUnselected();
    });
  }

  async addToCart() {
    const dialogRef = this.dialog.open(WaitModalComponent, {});

    const instance = dialogRef.componentInstance;
    dialogRef.disableClose = true;
    instance.state = 'PROCESSING';

    instance.titles = {
      PROCESSING: this.currentCartIsOrder ? 'Adding to Order...' : 'Adding to Cart...',
      ERROR: this.currentCartIsOrder ? 'Add to Order Error' : 'Add to Cart Error',
      DONE: this.currentCartIsOrder ? 'Added to Order' : 'Added to Cart'
    };

    instance.text = {
      PROCESSING: this.currentCartIsOrder ? 'Please wait while we add your item to the order.' : 'Please wait while we add your order to cart.',
      ERROR: this.currentCartIsOrder ? 'We encountered an unexpected error while adding the item to your order.' : 'We encountered an unexpected error while adding to cart.',
      DONE: this.currentCartIsOrder ? 'Your order has been added to your order.' : 'Your order has been added to cart.'
    };

    instance.yesButton = {
      text: this.currentCartIsOrder ? 'Review Order' : 'View Cart'
    };

    instance.noButton = {
      text: 'Continue Shopping'
    };

    dialogRef.afterClosed().subscribe( (result:boolean) => {
      if (result) {
        this.router.navigateByUrl(this.currentCartIsOrder ? '/order' : '/cart');
      }
    });

    try {
      const res = await this.cartService.addProject(this.product.project);
      instance.state = 'DONE';

      // track the add to cart in google analytics
      this.seoService.trackGAEcommEvent('add_to_cart', res.orderlines[res.orderlines.length - 1]);

      delete this.product.project;
      ['topMat', 'bottomMat', 'moulding', 'backingBoard', 'glazing'].forEach(prop => {
        this.productCategories[prop].selection = [];
      });
      await this.initializeProject();
    } catch {
      instance.state = 'ERROR';
    }
  }

  stopProp($event): void {
    $event.stopPropagation();
  }

  bagData: Array<any>;
  currentCartIsOrder: boolean = false;

  productCategories: any = {
    topMat: {
      projectProperty: 'topMat',
      projectDataProperty: 'mats',
      type: 'MAT',
      filterOptions: null,
      thumbPrefix: '/assets/images/products/mats/',
      thumbPostfix: '.jpg',
      title: 'Primary Mat Color',
      helpInfo: {
        title: 'Matboards',
        message: '<p>Adding a mat to your frame purchase can enhance the over all look and give you that pop of color you need.</p>' +
        '<p>We recommend getting foam backing & plexiglass with your frame.</p>'
      },
      cols: 4,
      scrollToTopAfterSelection: true,
      selection: [],
      layers: [{title: 'Primary Mat', projectProperty: 'topMat'}],
    },
    bottomMat: {
      projectProperty: 'bottomMat',
      projectDataProperty: 'mats',
      type: 'MAT',
      dependencies: ['topMat'],
      missingDependencyMessage: ['Select Primary Mat to Enable <i>(Optional)</i>'],
      filterOptions: null,
      thumbPrefix: '/assets/images/products/mats/',
      thumbPostfix: '.jpg',
      title: 'Accent Mat Color',
      helpInfo: {
        title: 'Matboards',
        message: '<p>An accent or bottom mat is an optional second layer of matting that goes below your primary layer.</p>' +
        '<p>Typically 1/4" of the accent layer shows.  This is called the reveal.</p>' +
        '<p class="image shadow"><img src="/assets/images/help/accent-mat.jpg" alt="Matboard Accent Layer" /></p>'
      },
      cols: 4,
      scrollToTopAfterSelection: true,
      selection: [],
      layers: [{title: 'Accent Mat', projectProperty: 'bottomMat', projectDependencies: ['topMat', 'opening']}],
    },
    moulding: {
      projectProperty: 'moulding',
      projectDataProperty: 'moulding',
      type: 'FRAME',
      title: 'Frame',
      cols: 4,
      mobileCols: 2,
      choice: null,
      choices: [
        {
          icon: 'check',
          color: 'green',
          value: true
        },
        {
          icon: 'x',
          color: 'red',
          value: false
        }
      ],
      products: [],
      thumbPrefix: '/assets/images/products/frames/',
      thumbPostfix: '/thumb.jpg',
      groupThumbPostfix: '/front-thumb.jpg',
      helpInfo: {
        title: 'Picture Frame Options',
        message: '<p>We offer custom cut frames in a variety of finishes & materials.  Our frames come ready to hang with saw tooth hangers.</p>' +
        '<div class="image labels"><img src="/assets/images/help/frame-anatomy.jpg" alt="Anatomy of a Matboard"/><span>Backing Board</span>' +
        '<span>Artwork</span><span>Accent Mat</span><span>Primary Mat</span><span>Plexiglass</span>' +
        '<span class="hl">Picture Frame</span></div>' +
        '<p>We recommend getting foam backing & plexiglass with your frame.</p>'
      },
      selection: [],
      scrollToTopAfterSelection: true
    },
    backingBoard: {
      projectProperty: 'backingBoard',
      projectDataProperty: 'backingBoard',
      title: 'Backing Board',
      type: 'BACKINGBOARD',
      simpleSize: true,
      cols: 3,
      mobileCols: 2,
      choice: null,
      choices: [
        {
          icon: 'check',
          color: 'green',
          value: true
        },
        {
          icon: 'x',
          color: 'red',
          value: false
        }
      ],
      products: [],
      defaultProductCode: 'FOAM',
      thumbPrefix: '/assets/images/products/backingboards/',
      thumbPostfix: '.jpg',
      helpInfo: {
        title: 'Backing Boards',
        message: '<p>Backing boards are used to protect the back of your print, they are separate uncut pieces.</p>' +
        '<p>We custom cut our backing boards to match the outer size of your matboard.</p>' +
        '<div class="image labels"><img src="/assets/images/help/frame-anatomy.jpg" alt="Anatomy of a Matboard" /><span class="hl">Backing Board</span>' +
        '<span>Artwork</span><span>Accent Mat</span><span>Primary Mat</span><span>Plexiglass</span><span>Picture Frame</span></div>'
      },
      scrollToTopAfterSelection: false,
      selection: []
    },
    glazing: {
      projectProperty: 'glazing',
      projectDataProperty: 'glazing',
      type: 'GLAZING',
      title: 'Plexiglass',
      cols: 1,
      mobileCols: 1,
      choice: null,
      choices: [
        {
          icon: 'check',
          color: 'green',
          value: true
        },
        {
          icon: 'x',
          color: 'red',
          value: false
        }
      ],
      products: [],
      defaultProductCode: 'PLEXIGLASS',
      thickerDefaultProductCode: 'PLEXIGLASSPREMIUM',
      thumbPrefix: '/assets/images/products/glazings/',
      thumbPostfix: '.jpg',
      helpInfo: {
        title: 'Plexiglass Glazing',
        message: '<p>Plexiglass is a great alternative for glass that is durable and clear.</p>' +
        '<p>We custom cut our plexiglass to fit your matboard outer size and to fit snugly with our frames.</p>' +
        '<div class="image labels"><img src="/assets/images/help/frame-anatomy.jpg" alt="Anatomy of a Matboard" /><span>Backing Board</span>' +
        '<span>Artwork</span><span>Accent Mat</span><span>Primary Mat</span>' +
        '<span class="hl">Plexiglass</span><span>Picture Frame</span></div>'
      },
      scrollToTopAfterSelection: false,
      selection: []
    }
  };

  async ngOnInit() {
    this.cartChangedSubRef = CartService.currentCartChanged.subscribe( (currentCart) => {
      this.currentCartIsOrder = currentCart ? currentCart.orderConfirmationNumber : false;
    });

    // TODO: remove when html links all removed
    if (this.product.builderButton && this.product.builderButton.link) {
      this.product.builderButton.link = this.product.builderButton.link.replace(/.html/g, '');
    }

    if (this.product.projectData) {
      this.bagData = await this.productsService.get('bags', false);
      const activeOrNull = (dt, parts) => {
        for (const p of parts) {
          if (Array.isArray(dt[p])) {
            let inactivePartsInSet = 0;
            for (const subPart of dt[p]) {
              if (!subPart.active) {
                inactivePartsInSet++;
              }
            }
            if (inactivePartsInSet === dt[p].length) {
              return false;
            }
          } else {
            if (dt[p] && !dt[p].active) {
              return false;
            }
          }
        }
        return true;
      };
      const projectData = this.product.projectData;
      if (projectData) {
        projectData.topMats = projectData.mats ? projectData.mats[0] : null;
        projectData.bottomMats = projectData.mats && projectData.mats[1] ? projectData.mats[1] : null;
        this.product.active = activeOrNull(this.product.projectData, ['topMats', 'bottomMats', 'bag', 'moulding', 'glazing', 'backingBoard']);

        if (projectData.topMats && !projectData.bottomMats) {
          this.productCategories.topMat.title = 'Choose Color';
          this.productCategories.topMat.titleAfterChosen = 'Color';
        }

        this.productCategories.topMat.products = projectData.topMats;
        this.productCategories.bottomMat.products = projectData.bottomMats;
      }
    }
    await this.initializeProject();
  }

  ngOnDestroy() {
    if (this.selectedProductChangeSubRef && !this.selectedProductChangeSubRef.closed) {
      this.selectedProductChangeSubRef.unsubscribe();
    }

    if (this.cartChangedSubRef && !this.cartChangedSubRef.closed) {
      this.cartChangedSubRef.unsubscribe();
    }

    if (this.projectChangeSubRef && !this.projectChangeSubRef.closed) {
      this.projectChangeSubRef.unsubscribe();
    }
  }

  async initializeProject() {
    const data: any = this.initialProjectData();
    if (data) {
      // if incomplete data, set a size (for preview purposes)
      if (!data.openings && !data.outerSize) {
        data.outerSize = '8x10';
        data.openings = [new Opening(Project.DEFAULTS.openingSize, [Shape.DEFAULT])];
      }

      // create a project for this product based on its project data
      this.product.project = new Project(data);

      // in fixed (set) price scenario, set the price once
      if (this.product.setPrice) {
        this.product.project.updatePrice({
          price: this.product.price,
          minPrice: this.product.salePrice ? this.product.salePrice : this.product.price,
          maxPrice: this.product.regularPrice
        });
      }

      // things to do when the project changes
      const updateProject = async (project: Project, forcePreviewMode = false) => {
        // update project price (if qty and not a fixed price)
        if (project.qty > 0 && !this.product.setPrice) {
          const priceData = await this.projectService.getPrice(project, true);
          project.updatePrice(priceData);
        }

        // update project image
        if (this.product.thumbPreviewStyle === 'GENERATED') {
          this.product.image = {
            src: project.url(450),
            largeImageSrc: project.url(700),
            shadow: project.primaryProduct !== 'VALUE-PACK' && this.product.project.primaryProduct !== 'SHOW-KIT'
          }
        }

        // whether to be in preview mode (only used on a manual call)
        this.projectIsPreview = forcePreviewMode;
      }

      // listen to project changes
      this.projectChangeSubRef = this.product.project.change.subscribe(updateProject);

      // update the project to get a price and preview (and set preview mode)
      await updateProject(this.product.project, !this.product.setPrice && this.product.project.primaryProduct !== 'SHOWBAG' && this.product.project.primaryProduct !== 'GC');
    }
  }

  initialProjectData(): any {
    if (!this.product.projectData) {
      return null;
    }

    const pData = Object.assign({}, this.product.projectData);

    const data: any = {
      outerSize: pData.outerSize,
      openings: pData.openings ? pData.openings : null,
      qty: this.product.project ? this.product.project.qty : (this.product.qtyBoxValues ? this.product.qtyBoxValues[0] : 1),
      topMat: this.productCategories.topMat.selection.length === 1 ? this.productCategories.topMat.selection[0] : (pData.topMat ? pData.topMat : pData.mats ? pData.mats[0][0] : null),
      bottomMat: pData.bottomMat ? pData.bottomMat : pData.mats && pData.mats[1] ? pData.mats[1][0] : null,
      moulding: pData.moulding ? pData.moulding : null,
      glazing: pData.glazing ? pData.glazing : null,
      backingBoard: pData.backingBoard ? pData.backingBoard : null,
      bag: pData.bag ? pData.bag : null,
      design: pData.design ? pData.design : (pData.designId ? {id: pData.designId} : null),
      permanentDesignId: pData.permanentDesignId,
      complexityUpCharge: pData.complexityUpCharge,
      primaryProduct: pData.primaryProduct,
      reveal: pData.reveal ? pData.reveal : 0,
      print: pData.print
    };

    if (this.product.setPrice) {
      data.preConfiguredProductId = this.product.id;
    }

    return data;
  }

  get thumbOrientation(): string {
    if (this.product.thumbPreviewStyle === 'STATIC') {
      return this.product.image && this.product.image.aspectRatio > 1 ? 'landscape' : 'portrait';
    } else {
      return this.product.project?.orientation ?? 'portrait';
    }
  }
}
